<script setup lang="ts">
import merge from 'lodash-es/merge';
import type { ListItemModel } from '../../_runtime/services/DescriptionPagesService';
import DescriptionPagesService from '../../_runtime/services/DescriptionPagesService';

defineOptions({
    name: 'WkDescriptionPagesSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue',): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    descriptionPageId: null
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

async function fetchDescriptionPage(id: number): Promise<ListItemModel>
{
    const response = await DescriptionPagesService.fetchAutocompleteModel(id);

    return response || null;
}

async function searchDescriptionPage(query: string, limit: number): Promise<ListItemModel[]>
{
    return await DescriptionPagesService.getAutocompleteList(query, limit);
}

function triggetModel(): void
{
    emit('update:modelValue', form.value);
}

watch(() => form.value.settings, () =>
{
    triggetModel();
}, { deep: true });

onBeforeMount((): void =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Wybierz stronę opisową]]]')">
        <IdeoAutocomplete
            v-model="form.settings.descriptionPageId"
            name="descriptionPageId"
            track-by="id"
            :placeholder="$t('[[[Wyszukaj strony...]]]')"
            :default-label="$t('[[[Brak strony]]]')"
            :fetch="(id: number) => fetchDescriptionPage(id)"
            :search="(query: string, limit: number) => searchDescriptionPage(query, limit)"
        >
            <template #selected="{ option }">
                <div class="text-wrap">
                    {{ option.title }}
                </div>
            </template>
            <template #option="{ option }">
                <div class="text-wrap">
                    {{ option.title }}
                </div>
            </template>
        </IdeoAutocomplete>
    </IdeoFormGroup>
</template>
